import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';

export const OVERLAY_SLICE_KEY = 'overlay';

export interface OverlaySliceState {
  visible: boolean;
  remainingTime: string;
  resultOverlayVisible: boolean;
  resultBasket: 'A' | 'B' | 'C' | null;
  menuPopupOpen: boolean;
  gameLimitsModalOpen: boolean;
  myBetsHistoryModalOpen: boolean;
  gameRulesModalOpen: boolean;
  customBetPopupOpen: boolean;
}

export const initialState: OverlaySliceState = {
  visible: false,
  remainingTime: '0',
  resultOverlayVisible: false,
  resultBasket: null,
  menuPopupOpen: false,
  gameLimitsModalOpen: false,
  myBetsHistoryModalOpen: false,
  gameRulesModalOpen: false,
  customBetPopupOpen: false,
};

const overlaySlice = createSlice({
  name: OVERLAY_SLICE_KEY,
  initialState,
  reducers: {
    setOverlayVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    toggleOverlay: (state) => {
      state.visible = !state.visible;
    },
    setRemainingTime: (state, action: PayloadAction<string>) => {
      state.remainingTime = action.payload;
    },
    setResultOverlay: (
      state,
      action: PayloadAction<{ basket: 'A' | 'B' | 'C' }>
    ) => {
      state.resultOverlayVisible = true;
      state.resultBasket = action.payload.basket;
    },
    hideResultOverlay: (state) => {
      state.resultOverlayVisible = false;
      state.resultBasket = null;
    },
    setMenuPopupOpen: (state, action: PayloadAction<boolean>) => {
      state.menuPopupOpen = action.payload;
    },
    setGameLimitsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.gameLimitsModalOpen = action.payload;
    },
    setMyBetsHistoryModalOpen: (state, action: PayloadAction<boolean>) => {
      state.myBetsHistoryModalOpen = action.payload;
    },
    setGameRulesModalOpen: (state, action: PayloadAction<boolean>) => {
      state.gameRulesModalOpen = action.payload;
    },
    setCustomBetPopupOpen: (state, action: PayloadAction<boolean>) => {
      state.customBetPopupOpen = action.payload;
    },
  },
});

const overlayReducer = overlaySlice.reducer as Reducer;

export default overlayReducer;

export const overlaySelector = (state: {
  [OVERLAY_SLICE_KEY]: OverlaySliceState;
}) => state[OVERLAY_SLICE_KEY];

export const overlayActions = overlaySlice.actions;
